export default "__VITE_ASSET__THhHHwdJ__"